import React, { useEffect } from 'react';
import { gsap } from 'gsap';
import './About.css';

const About = () => {
  const containerRef = React.useRef(null);
  const imageRef = React.useRef(null);
  const textRef = React.useRef(null);

  useEffect(() => {
    // Animación de entrada
    const tl = gsap.timeline();
    tl.fromTo(imageRef.current,
      { opacity: 0, scale: 0.95 },
      { opacity: 1, scale: 1, duration: 1, ease: 'power3.out' }
    )
    .fromTo(textRef.current,
      { opacity: 0, y: 30 },
      { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out' },
      '-=0.5'
    );
  }, []);

  return (
    <section className="about-section">
      <div className="about-container" ref={containerRef}>
        <div className="about-text" ref={textRef}>
          <div className="about-header">
            {/* <h1>Biography</h1> */}
            <div className="subtitle">Biography</div>
          </div>

          <div className="biography">
            <p>
              Thanks to light, beauty happens naturally, unique and unrepeatable like life itself. The 
              soft texture of film photography is similar to oil paintings while the colors emerge intense 
              and true, often making digital retouching superfluous.
            </p>

            <p>
              With landscape photography and still life I return the profound sense of bewilderment I 
              feel when faced with the world. In portraits as in fashion photography I try to go beyond 
              beauty to capture the emotions and character of the protagonists.
            </p>

            <p>
              From the conception to the final production, I can create advertising campaigns, fashion 
              ADV and editorials. I collaborated with numerous magazines including <em>Lula Japan</em>, 
              <em>Contributor</em>, <em>Cap 74024</em>, <em>Folie</em>, <em>Calle 52</em>, <em>Solstice</em>,   
              <em> Spaghetti</em>, <em>Flanelle</em>, <em>Kluid Magazine</em> and <em>The Inspired Co</em>.
            </p>
          </div>
        </div>

        <div className="about-image-container" ref={imageRef}>
          <img 
            src={require('../../assets/aboutme.jpg')} 
            alt="Angelica Erta"
                className="about-image"
            />
        </div>
      </div>
    </section>
  );
};

export default About;
